import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import { toast } from 'react-toastify';

export default function ApplyPage() {
  const { internshipId } = useParams();
  const navigate = useNavigate();
  const [internship, setInternship] = useState(null);
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    qualification: '',
    reason: ''
  });

  useEffect(() => {
    api.get(`/internships/${internshipId}`)
      .then(res => setInternship(res.data))
      .catch(() => toast.error('Failed to load internship'));
  }, [internshipId]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await api.post('/apply', { internship_id: internshipId, ...form });
      toast.success('Application submitted!');
      navigate('/');
    } catch (err) {
      toast.error('Submission failed');
    }
  };

  return (
    <div className="container py-5" style={{ maxWidth: '600px' }}>
      <h2 className="text-center mb-4 text-primary">Internship Application</h2>

      {internship && (
        <div className="bg-white p-3 rounded shadow-sm mb-4">
          <h5 className="text-dark">{internship.title}</h5>
          <p className="text-muted mb-0">{internship.description}</p>
        </div>
      )}

      <form onSubmit={handleSubmit} className="border p-4 rounded bg-white shadow-sm">
        <div className="mb-3">
          <label className="form-label fw-semibold">Full Name</label>
          <input
            type="text"
            name="name"
            className="form-control"
            required
            value={form.name}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            required
            value={form.email}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Phone</label>
          <input
            type="tel"
            name="phone"
            className="form-control"
            value={form.phone}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Qualification</label>
          <input
            type="text"
            name="qualification"
            className="form-control"
            value={form.qualification}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Why are you interested?</label>
          <textarea
            name="reason"
            className="form-control"
            rows={3}
            value={form.reason}
            onChange={handleChange}
          />
        </div>

        <div className="text-center">
          <button type="submit" className="btn btn-primary w-100">Submit Application</button>
        </div>
      </form>
    </div>
  );
}
